const pollData = {
  currentPoll: {
    // id: "S49-postseason",
    id: null,
  },
  previousPoll: {
    id: "S49-postseason",
    // id: null,
  },
};

export default pollData;
